import React from 'react';

const MainPage = () => {
  const handleRegClick = () => {
    window.open('https://forms.gle/JKRjfmDV7fX9YTQx5', '_blank');
  };

  const handleLamClick = () => {
    window.open('https://drive.google.com/file/d/1qBFPn0cX07aJt3dIQUxU7syrhPquhTGv/view', '_blank')
  }

  return (
    <main>
      <section className="top-bg">
        <div className="top-fg">
          <div className="top-bar-btns">
            <button className="reg-btn" onClick={handleRegClick}>
              регистрация
            </button>
            <button className="reg-btn" onClick={handleLamClick}>
              регламент
            </button>
          </div>
        </div>
      </section>

      <section className="sim-screen">
        <div className="sim-info">
          <div className="sim-info-top">
            <span>Лучший симулятор</span>
            <span>Топовое оборудование</span>
          </div>
          <div className="sim-info-bot">
            <span>Условия участия</span>
            <div className="arrow bounce"></div>
          </div>
        </div>
      </section>

      <section className="rules-and-prizes">
        <ol className="rules">
          <li>
            <span>
              Чемпионат проводится на базе <strong>CRC MOTORSPORT</strong>;
            </span>
          </li>
          <li>
            <span>
              Стартовый взнос для каждого участника - <strong>1500 грн.</strong>
              ;
            </span>
          </li>
          <li>
            <span>
              Квалификационные заезды длительностью по
              <strong> 30 минут</strong> запланированы на период c 08.01.2022 по
              14.01.2022, точная дата для каждого пилота согласовывается с
              менеджером;
            </span>
          </li>
          <li>
            <span>
              После квалификации пилоты будут разделены на три группы по навыкам
              и для каждого будет назначена новая дата для заездов за призовые
              места (не позднее 23.01.2022);
            </span>
          </li>
          <li>
            <span>
              Количество пилотов в каждом классе не более
              <strong> 33 человек</strong>;
            </span>
          </li>
          <li>
            <span>
              Все пилоты класса будут в равных условиях, на одинаковом
              автомобиле на одной и той же трассе;
            </span>
          </li>
          <li>
            <span>
              Каждому участнику в боевых заездах будет дано{' '}
              <strong>40 минут </strong>
              для достижения лучшего времени круга;
            </span>
          </li>
        </ol>
        <div className="prizes">
          <h2>Призы в трёх классах</h2>

          <h3>PRO</h3>

          <div className="flex-line">
            <span>1st:</span>
            <span>10000 грн.</span>
          </div>
          <div className="flex-line">
            <span>2nd:</span>
            <span>8000 грн.</span>
          </div>
          <div className="flex-line">
            <span>3rd:</span>
            <span>6000 грн.</span>
          </div>

          <h3>Sport</h3>

          <div className="flex-line">
            <span>1st:</span>
            <span>5000 грн.</span>
          </div>
          <div className="flex-line">
            <span>2nd:</span>
            <span>4000 грн.</span>
          </div>
          <div className="flex-line">
            <span>3rd:</span>
            <span>3000 грн.</span>
          </div>

          <h3>Street</h3>

          <div className="flex-line">
            <span>1st:</span>
            <span>2500 грн.</span>
          </div>
          <div className="flex-line">
            <span>2nd:</span>
            <span>2000 грн.</span>
          </div>
          <div className="flex-line">
            <span>3rd:</span>
            <span>1500 грн.</span>
          </div>
        </div>
      </section>

      <section className="classes">
        <div className="qual">
          <span>
            пройди{' '}квалификацию{' '}в{' '}один{' '}из{' '}классов{' '}и{' '}сражайся{' '}на{' '}равных{' '}с{' '}другими{' '}
            соперниками
          </span>
          <div className="arrow-bottom bounce"></div>
        </div>
      </section>

      <section className="sim-bg">
        <div className="sim">
          <p>
            Подвижная платформа <strong>T1000 3-DOF </strong>для передачи{' '}
            настоящих ощущений за рулем
          </p>
          <p>
            Педали <strong>Meca CUP-1 </strong>с технологией LOADCELL. Педаль{' '}
            тормоза эффективно измеряет давление до{' 200'}кг.
          </p>
          <p>
            Рулевая база <strong>Direct Drive Simagic Aplha Mini </strong> +{' '}
            руль, который даёт 10Нм усилия и эффектов.
          </p>
          <p>
            Три дисплея 32 дюйма с частотой обновления 144Гц и откликом{' 1'}мс
          </p>
          <p>Не упусти свой шанс стать лучшим sim-рейсером Днепра!</p>
          <button className="reg-btn bottom-btn" onClick={handleRegClick}>
            регистрация
          </button>
        </div>
      </section>
    </main>
  );
};

export default MainPage;
